export const TEMPLATE_SPLIT = '|';

export const AUTO_ACQUISITIONSTATUS_MAP = {
  'AUTO_ACQUISTION_STATUS_UNKNOW': {
    label: '未开启',
  },
  'AUTO_ACQUISTION_STATUS_PENDING': {
    label: '起量中',
  },
  'AUTO_ACQUISTION_STATUS_END_LESS_THAN_24H': {
    label: '起量完成',
    tip: '探索结束，预算花完，但距离广告开启功能未满24小时',
  },
  'AUTO_ACQUISTION_STATUS_END_MORE_THAN_24H': {
    label: '起量完成',
    tip: '探索结束，预算花完，但距离广告开启功能已满24小时',
  },
  'AUTO_ACQUISTION_STATUS_COMPLETED': {
    label: '起量结束',
    tip: '探索结束，距离广告开启已满6小时，但预算未花完（实际花费＜起量预算*90%）',
  },
  'AUTO_ACQUISTION_STATUS_SUSPEND_ON_LEARNING_FAIL': {
    label: '起量中止',
    tip: '探索过程中，广告被判定为学习失败，从而探索中止',
  },
  'AUTO_ACQUISTION_STATUS_SUSPEND_ON_PLAYING_FAIL': {
    label: '起量中止',
    tip: '探索过程中，因广告无法播放，从而起量中止（包括广告主动或被动下线或 timeset 不连续）',
  },
  'AUTO_ACQUISTION_STATUS_ADVERTISER_CLOSED': {
    label: '关闭起量',
  },
};
